module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "id": "CONTENTS"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "center1"
  }, [_c('table', {
    staticClass: "calibre12",
    attrs: {
      "border": "0",
      "cellpadding": "4",
      "cellspacing": "0",
      "summary": "Table of Contents."
    }
  }, [_c('tbody', {
    staticClass: "calibre13"
  }, [_c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "calibre15"
  }), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PAGE")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004#I"
    }
  }, [_vm._v("The Cabuliwallah")])])]), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_vm._v("3")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005#II"
    }
  }, [_vm._v("The Home-Coming")])])]), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_vm._v("21")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006#III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Once there was a King")])])]), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_vm._v("35")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007#IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Child's Return")])])]), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_vm._v("51")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008#V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Master Mashai")])])]), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_vm._v("69")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009#VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subha")])])]), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_vm._v("101")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Postmaster")])])]), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_vm._v("115")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Castaway")])])]), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_vm._v("129")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Son of Rashmani")])])]), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_vm._v("151")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Babus of Nayanjore")])])]), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_vm._v("203")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre14"
  }, [_c('td', {
    staticClass: "desc"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#NOTES",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('td', {
    staticClass: "pgno"
  }, [_vm._v("223")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00002",
      "title": "[Pg 1]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_1",
      "title": "[Pg 1]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "prechap"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00004",
      "title": "[Pg 3]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_3",
      "title": "[Pg 3]"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0